module.exports = __webpack_public_path__ + "static/media/sls_logo.50d124fb.png";